import { useQuery } from '@tanstack/react-query';
import {
  getActiveUsers,
  getAmountOfRegistrations,
  getFailedTasks,
  getSkippedTasks,
} from 'api/users.service';
import { updatePeriodicalUsersStatistics } from 'hooks/helpers';

export const useStatisticsGetAllQuery = () => {
  const { isLoading: isActiveUsersLoading, data: activeUsers } = useQuery({
    queryKey: ['active/users'],
    queryFn: getActiveUsers,
  });
  const {
    isLoading: isAmountOfRegistrationsLoading,
    data: amountOfRegistrations,
  } = useQuery({
    queryKey: ['registrations/users'],
    queryFn: getAmountOfRegistrations,
  });
  const { isLoading: isSkippedTasksLoading, data: skippedTasks } = useQuery({
    queryKey: ['skipped/tasks'],
    queryFn: getSkippedTasks,
  });
  const { isLoading: isFailedTasksLoading, data: failedTasks } = useQuery({
    queryKey: ['failed/tasks'],
    queryFn: getFailedTasks,
  });

  return {
    isLoading:
      isActiveUsersLoading ||
      isAmountOfRegistrationsLoading ||
      isSkippedTasksLoading ||
      isFailedTasksLoading,
    activeUsers: updatePeriodicalUsersStatistics(activeUsers),
    amountOfRegistrations: updatePeriodicalUsersStatistics(
      amountOfRegistrations,
    ),
    skippedTasks,
    failedTasks,
  };
};
